import React from "react";
import { Row, Col } from "reactstrap";
import { Button } from "antd";
import { Link } from "react-router-dom";
import Lottie from "lottie-react";
import { motion } from "framer-motion";
import cardAnim from "../assets/animations/cardMoney.json";
import comingSoonAnim from "../assets/animations/comingAnim.json";

const ComingSoon = () => {
  return (
    <div style={{ position: "relative", overflow: "hidden", maxHeight: "100vh" }}>
      <Row className="justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
        <Col md="8" className="text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{ width: 300, margin: "0 auto", marginBottom: "-50px" }}
          >
            <Lottie animationData={cardAnim} loop autoplay style={{ marginBottom: "-70px" }} />
            <Lottie animationData={comingSoonAnim} loop autoplay style={{ marginBottom: "-90px" }} />
          </motion.div>

          <motion.h2
            className="mb-4 mt-2"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.6 }}
          >
            Cette page sera bientôt disponible
          </motion.h2>

          <motion.p
            style={{ fontSize: "16px", color: "#666" }}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.6 }}
          >
            Nous y travaillons et elle sera disponible très prochainement.
          </motion.p>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.7, duration: 0.6 }}
          >
            <Link to="/dashboard">
              <Button type="primary" size="large">
                Retour à l’accueil
              </Button>
            </Link>
          </motion.div>
        </Col>
      </Row>
    </div>
  );
};

export default ComingSoon;
